import React from 'react';
import { Profile } from '../../profile/profile';
import {
  BuildingDataWrapper,
  DeskRailIndicator,
  IconContainer,
  IconWrapper,
  SidebarContainer,
  SidebarWrapper,
} from './sidebar.styled';
import { IndicatorGroup } from '../../../motion';
import { LogoMark } from '../../logo/logo-mark';
import { VisitorLogIcon } from '../../icons/visitor-log';
import { DailyLogIcon } from '../../icons/daily-log';
import { NavigateFunction } from 'react-router-dom';
import { BuildingData } from '../../building-data/building-data';
import { palette } from '../../../style-utils/theme';
import { BuildingData as Building } from '../../../interfaces/building-interfaces';

interface SidebarProps {
  navigate: NavigateFunction;
  selectedOption: string;
  path?: string;
  selectedBuilding?: Building | null;
  buildings?: Building[];
  buildingsLoading?: boolean;
  onSelectBuilding?: (buildingId: string) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({
  navigate,
  selectedOption,
  path,
  selectedBuilding,
  buildings = [],
  buildingsLoading = false,
  onSelectBuilding,
}) => {
  const isVisitorLogHighlighted = selectedOption === '/visitor-log';
  const isDailyLogHighlighted = selectedOption === '/daily-log';

  const isMainMenu = path === '/main-menu';

  return (
    <SidebarWrapper showBuildingContext={isMainMenu}>
      <SidebarContainer>
        {/* No bell here. It used to live in this rail, which meant it existed
            for staff and not for residents, and moved around whenever the rail
            did. It is now NotificationDock, mounted once in App.tsx and pinned
            to the top-right corner of every screen. */}
        <LogoMark size={40} role="img" aria-label="Lobbero" />
        {/* A LANDMARK ONLY WHEN IT HOLDS NAVIGATION. On /main-menu this rail
            renders no destinations at all, and an empty <nav> is a landmark
            that promises a reader something and then has nothing in it. */}
        <IconContainer
          as={isMainMenu ? undefined : 'nav'}
          aria-label={isMainMenu ? undefined : 'Main'}
        >
          {!isMainMenu && (
            /* The accent bar is ONE element that slides between the two
               destinations (see DeskRailIndicator); the group scopes its
               layoutId to this rail. */
            <IndicatorGroup id="desk-rail">
              <IconWrapper
                type="button"
                aria-label="Open Visitor Log"
                aria-current={isVisitorLogHighlighted ? 'page' : undefined}
                isHighlighted={isVisitorLogHighlighted}
                onClick={() => navigate('/visitor-log', { replace: false })}
              >
                {isVisitorLogHighlighted && (
                  <DeskRailIndicator
                    id="desk-rail"
                    data-active-indicator="true"
                  />
                )}
                <VisitorLogIcon
                  stroke={
                    isVisitorLogHighlighted ? palette.iris : palette.slate
                  }
                />
              </IconWrapper>
              <IconWrapper
                type="button"
                aria-label="Open Building Activities"
                aria-current={isDailyLogHighlighted ? 'page' : undefined}
                isHighlighted={isDailyLogHighlighted}
                onClick={() => navigate('/daily-log', { replace: false })}
              >
                {isDailyLogHighlighted && (
                  <DeskRailIndicator
                    id="desk-rail"
                    data-active-indicator="true"
                  />
                )}
                <DailyLogIcon
                  stroke={isDailyLogHighlighted ? palette.iris : palette.slate}
                />
              </IconWrapper>
            </IndicatorGroup>
          )}
        </IconContainer>
        <Profile />
      </SidebarContainer>
      <BuildingDataWrapper showOnCompact={isMainMenu}>
        <BuildingData
          buildingData={selectedBuilding}
          buildings={buildings}
          loading={buildingsLoading}
          selectable={isMainMenu}
          onSelectBuilding={onSelectBuilding}
        />
      </BuildingDataWrapper>
    </SidebarWrapper>
  );
};
